/**
 * Devuelve los objetos de configuración del tree.
 * Se prepara/tranforma el metadata.tree que viene del view.
 *
 * @param {object} viewField el campo del view
 * @param {string} parentPath el xPath del registro padre
 * @return {object}
 */
export function readMetadata(viewField, parentPath) {
  const metadataViewTree = viewField.metadata.tree; // el array de objetos del view, `metadata.tree`. Que define el fbTree.
  const basePath = parentPath ? `${parentPath}.` : '';
  const titles = findTitles(viewField);

  const config = createConfig(metadataViewTree, basePath, titles);
  const treeNodes = config.map(({ model }) => model);

  return { config, treeNodes };
}

/**
 * Prepara el config.
 * Lo clonea para evitar problemas,
 * y añade la base del modelo a los "model" que son relativos.
 * (Eso es en especial para cuando se usa dentro de un include, donde el padre se conoce solo al runtime)
 *
 * @param {object} metadataViewTree El metadata.view.tree
 * @param {string} basePath El modelo del registro padre, es el `parentPath`. Ej. "CAB.LIN"
 * @param {object<string>} titles Objeto {[model]: title} de todos los hijos del viewField
 */
function createConfig(metadataViewTree, basePath, titles) {
  const config = [];
  handleNodes(metadataViewTree);
  return config;

  function handleNodes(nodes) {
    nodes.forEach(item => {
      if (!item.model) {
        throw new Error(`Es obligatorio indicar el "model" para cada nodo del metadata.tree`);
      }

      // buscamos el title (que puede venir de los campos hijos en el viewField.properties)
      item.title = item.title || titles[basePath + item.model] || titles[item.model] || '';

      if (!item.title) {
        throw new Error(`Es obligatorio indicar el "title" para cada hijo del tree que esta en el metadata.tree`);
      }
      config.push({
        model: `${basePath}${item.model}`,
        name: item.name ? Object.assign([], item.name) : [{ text: item.title }], // ponemos title por defecto si no hay name
        title: item.title,
      });
      item.children && handleNodes(item.children);
    });
  }
}

/**
 * Devuelve un objeto con {model: title} para recuperar los titulos de cada nodo del tree
 *
 * @param {object} viewField el viewField, el campo del view tipo 'tree'
 * @return {object} {[model]: title}
 */
function findTitles(viewField) {
  const titles = {};

  flatmap([viewField], ({ title, model }) => {
    titles[model] = title;
  });

  return titles;
}

/**
 * Recorre todos los hijos y hijos de hijos de un viewField, y ejecuta una función `callback`.
 *
 * @param {object[]} properties el viewField corriente
 * @param {function} callback la función que se llama para cada viewField
 */
function flatmap(properties = [], callback = () => {}) {
  properties.forEach(prop => {
    callback(prop);
    prop.properties && flatmap(prop.properties, callback);
  });
}
